import React from 'react';
import { Outlet } from 'react-router-dom';
import { useScreenSize } from '../../hooks/useScreenSize';
import MembroMenu from './membro-menu/MembroMenu';
import MembroTopo from './membro-topo/MembroTopo';
import MembroTopoMobile from './membro-topo-mobile/MembroTopoMobile';
import MembroMenuMobile from './membro-menu-mobile/MembroMenuMobile';
import { Box } from '@mui/material';
import '../../styles/templates/MembroTemplate.scss';

const MembroTemplate: React.FC = () => {
  const { screenSize } = useScreenSize();

  if (screenSize === 'tablet') {
    return (
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <MembroMenu />
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <MembroTopo />
          <Box sx={{ flex: 1, overflow: 'auto' }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    );
  }

  if (screenSize === 'mobile') {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <MembroTopoMobile />
        <Box sx={{ flex: 1, overflow: 'auto', pb: 7 }}>
          <Outlet />
        </Box>
        <MembroMenuMobile />
      </Box>
    );
  }

  // Default desktop layout
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <MembroMenu />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <MembroTopo />
        <Box sx={{ flex: 1, overflow: 'auto' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default MembroTemplate; 